import { http } from '@/api/http'

export function listDutyTypes(params = {}) {
    return http.get('chpo/duty-types/', { params }).then(r => r.data.results || r.data)
}

export function createDutyType(payload) {
    return http.post('chpo/duty-types/', payload).then(r => r.data)
}

export function updateDutyType(id, payload) {
    return http.patch(`chpo/duty-types/${id}/`, payload).then(r => r.data)
}

export function deleteDutyType(id) {
    return http.delete(`chpo/duty-types/${id}/`).then(r => r.data)
}
